import { useEffect, useState } from "react"
import { useHistory, useParams } from "react-router"
import { DateDetaisBox } from "../components/DateDetailsBox"
import Loader from "../components/Loader"
import { PublicProfileHeader } from "../components/PublicProfileHeader"
import { PublicUser, User } from "../models/Users"
import { ProgStatus } from "../models/utilTypes"
import ApiService from "../services/ApiService"
import { rootStore } from "../StApp"
import img0 from '../eye-mask.svg'

type UserParams = {
    userName: string,
}

const api = ApiService

const dispStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '10px',
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'scroll'
};

export const UserPage = () => {

    useEffect(() => {
        document.title = 'SayToMe User'
    }, [])

    const [userState, setUserState] = useState<PublicUser>()
    const [loadState, setLoadState] = useState<ProgStatus>('INIT')
    const { userName } = useParams<UserParams>()
    const history = useHistory()

    useEffect(() => {

        if (userName == rootStore.mainStore.userName) {
            history.replace('/')
            rootStore.uiStore.appBarVisible = true
            return
        }

        if (loadState == 'INIT') {
            api.getUser({ userName: userName })
                .then((result) => {
                    setUserState(result.data)
                    setLoadState('SUCCESS')

                })
                .catch(err => {

                    setLoadState('FAILED')
                })

        }


    }, [])



    function getUser() {
        switch (loadState) {

            case 'INIT': return <Loader />
                break;

            case 'LOADING': return <Loader />
                break;

            case 'SUCCESS': return <DateDetaisBox
                user={userState!}
                data={{
                    user: userState!,
                    likeButton: false,
                    mainImgUrl: img0
                }}
                style={dispStyle}
            />
                break;

            case 'FAILED': return <div>Error</div>
        }
    }

    return (
        <div className='flex-column' style={{height: '100%'}} >
            <PublicProfileHeader />
            <div style={{ overflow: 'scroll' }} >
                {getUser()}</div>
        </div>
    )



}